module.exports = __webpack_public_path__ + "static/media/tenantInsuranceHouse.9e57dfea.png";